var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "atm_modal_installment",
        "hide-header-close": "",
        "hide-footer": "",
        scrollable: "",
        centered: "",
        size: "lg",
      },
      on: { hidden: _vm.onHidden },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _c("h5", { staticClass: "atm-title" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("Em quantas vezes deseja pagar?")) + " "
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "b-container",
        [
          _vm._l(_vm.stInstallmentOptions, function (option) {
            return _c(
              "b-row",
              { key: option.installments },
              [
                _c(
                  "b-col",
                  { staticClass: "mb-1" },
                  [
                    _c("e-button", {
                      staticClass: "atm-btn",
                      attrs: {
                        id: "atm_modal_installment-btn_" + option.installments,
                        variant: "primary",
                        text: _vm.optionLabel(option),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onConfirm(option)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mt-1" },
                [
                  _c("e-button", {
                    staticClass: "atm-btn",
                    attrs: {
                      id: "atm_modal_installment-btn_cancel",
                      variant: "danger",
                      text: _vm.$t("Cancelar"),
                    },
                    on: { click: _vm.onCancel },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }